<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-card-section>
        <q-form class="col-md-12" @submit.prevent.stop="finaliza">
          <div class="text-h6">Registro para {{donator.full_name}}</div>
          <div class="col-md-12 q-pa-md q-gutter-sm">
            <q-input outlined v-model="atendimento.title" label="Título"
                     :rules="[value => !!value  || 'Campo obrigatório']"/>
            <q-editor v-model="atendimento.description" dense toolbar-color="primary"/>
            <q-btn label="Registrar" type="submit" color="primary"/>
          </div>
        </q-form>
      </q-card-section>
    </div>
    <q-dialog v-model="saved">
      <q-card style="width: 300px">
        <q-card-section>
          <div class="text-h6">Sucesso</div>
        </q-card-section>

        <q-card-section>
          Dados registrados.
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="fecha"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-inner-loading :showing="$apollo.loading">
      <q-spinner-dots size="50px" color="primary"/>
    </q-inner-loading>
  </q-page>
</template>

<script>
import { DONATOR, ATENDIMENTO } from '../graphql/graphql'

export default {
  name: 'Atendimento',
  props: {
    id: {
      type: String
    }
  },
  apollo: {
    donator: {
      query: DONATOR,
      variables () {
        id: this.id
      },
      skip: true
    }
  },
  data () {
    return {
      atendimento: {
        title: '',
        description: '',
        donator_id: this.id
      },
      saved: false,
      donator: {}
    }
  },
  methods: {
    fecha () {
      this.saved = false
      this.atendimento.title = ''
      this.atendimento.description = ''
      this.atendimento.donator_id = ''
      this.$router.push({ name: 'doadores' })
    },
    finaliza () {
      this.$apollo.mutate({
        mutation: ATENDIMENTO,
        variables: {
          id: this.id,
          input: this.atendimento
        },
        update: (store, data) => {
          if (data.data.hasOwnProperty('atendimento')) {
            if (data.data.atendimento.hasOwnProperty('id')) {
              this.saved = true
            }
          }
        }
      })
    }
  },
  mounted () {
    console.log(this.id)
    /* this.$apollo.queries.donator.skip = false
    this.$apollo.queries.donator.setVariables({ id: this.id })
    this.$apollo.queries.donator.refetch().then(result => {
      this.donator = result.data.donator
    }) */
  }
}
</script>

<style scoped>

</style>
